import { z } from 'zod'

import { error as logError } from '../utils/logger'

const configSchema = z.object({
  APP_ENV: z
    .enum(['development', 'production', 'sandbox', 'ode', ''])
    .nullish()
    .transform((data) => data ?? undefined),
  APP_BASE_URL: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  API_ENDPOINT: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  PUBLIC_API_ENDPOINT: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  FEATURE_TOGGLES: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  STORAGE_ENV: z
    .enum(['development', 'production', 'sandbox', ''])
    .nullish()
    .transform((data) => data ?? undefined),
  DATADOG_RUM_APP_ID: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  DATADOG_RUM_CLIENT_TOKEN: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  DATADOG_RUM_SITE: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  DATADOG_RUM_SERVICE: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  FULLSTORY_ANALYTICS_ID: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  USERLANE_ID: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  SHIP_URL: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  GOOGLE_MAP_API_KEY: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
})

export type IConfig = z.infer<typeof configSchema>

const loadConfig = (): IConfig => {
  if (typeof window.config === 'undefined') {
    throw new Error('Configuration is not initialized on window.config')
  }

  try {
    return configSchema.parse(window.config)
  } catch (error) {
    if (error instanceof z.ZodError) {
      logError('Invalid configuration', JSON.stringify(error.errors))
    }
    throw new Error('Failed to load valid configuration')
  }
}

export const getConfig = (): IConfig => {
  let config: IConfig | null = null
  if (config === null) {
    try {
      config = loadConfig()
    } catch (error) {
      logError('Failed to load configuration', error)
      throw error
    }
  }
  return config
}
